/*!
 * CoverPop 2.5.1
 * http://coverpopjs.com
 *
 * Copyright (c) 2015 Tyler Pearson
 * Licensed under the MIT license: http://www.opensource.org/licenses/mit-license.php
 */
!function(e){"use strict";var o={coverId:"CoverPop-cover",expires:30,closeClassNoDefault:"CoverPop-close",closeClassDefault:"CoverPop-close-go",openClassDefault:"CoverPop-open",cookieName:"_CoverPop",onPopUpOpen:null,onPopUpClose:null,forceHash:"splash",delayHash:"go",closeOnEscape:!0,delay:0,hideAfter:null},s={},t={hasClass:function(e,o){return new RegExp("(\\s|^)"+o+"(\\s|$)").test(e.className)},addClass:function(e,o){t.hasClass(e,o)||(e.className+=(e.className?" ":"")+o)},removeClass:function(e,o){t.hasClass(e,o)&&(e.className=e.className.replace(new RegExp("(\\s|^)"+o+"(\\s|$)")," ").replace(/^\s+|\s+$/g,""))},addListener:function(e,o,s){e.addEventListener?e.addEventListener(o,s,!1):e.attachEvent&&e.attachEvent("on"+o,s)},removeListener:function(e,o,s){e.removeEventListener?e.removeEventListener(o,s,!1):e.detachEvent&&e.detachEvent("on"+o,s)},isFunction:function(e){var o={};return e&&"[object Function]"===o.toString.call(e)},setCookie:function(e,o){var s=new Date;s.setTime(+s+864e5*o),document.cookie=e+"=true; expires="+s.toGMTString()+"; path=/"},hasCookie:function(e){return-1!==document.cookie.indexOf(e)?!0:!1},hashExists:function(e){return-1!==window.location.hash.indexOf(e)?!0:!1},preventDefault:function(e){e.preventDefault?e.preventDefault():e.returnValue=!1},mergeObj:function(e,o){for(var s in o)e[s]=o[s]}},n=function(s){o.closeOnEscape&&27===s.keyCode&&e.close()},l=function(){if(null!==o.onPopUpOpen){if(!t.isFunction(o.onPopUpOpen))throw new TypeError("CoverPop open callback must be a function.");o.onPopUpOpen.call()}},a=function(){if(null!==o.onPopUpClose){if(!t.isFunction(o.onPopUpClose))throw new TypeError("CoverPop close callback must be a function.");o.onPopUpClose.call()}};e.open=function(){var a,c;if(t.hashExists(o.delayHash))return void t.setCookie(o.cookieName,1);if(t.addClass(s.html,o.openClassDefault),s.closeClassNoDefaultEls.length>0)for(a=0,c=s.closeClassNoDefaultEls.length;c>a;a++)t.addListener(s.closeClassNoDefaultEls[a],"click",function(o){o.target===this&&(t.preventDefault(o),e.close())});if(s.closeClassDefaultEls.length>0)for(a=0,c=s.closeClassDefaultEls.length;c>a;a++)t.addListener(s.closeClassDefaultEls[a],"click",function(o){o.target===this&&e.close()});t.addListener(document,"keyup",n),l()},e.close=function(){t.removeClass(s.html,o.openClassDefault),t.setCookie(o.cookieName,o.expires),t.removeListener(document,"keyup",n),a()},e.init=function(n){navigator.cookieEnabled&&(t.mergeObj(o,n),s={html:document.getElementsByTagName("html")[0],cover:document.getElementById(o.coverId),closeClassDefaultEls:document.querySelectorAll("."+o.closeClassDefault),closeClassNoDefaultEls:document.querySelectorAll("."+o.closeClassNoDefault)},(!t.hasCookie(o.cookieName)||t.hashExists(o.forceHash))&&(0===o.delay?e.open():setTimeout(e.open,o.delay),o.hideAfter&&setTimeout(e.close,o.hideAfter+o.delay)))},e.start=function(o){e.init(o)}}(window.CoverPop=window.CoverPop||{});
(function($){
    function startPopup(){
        
 
        CoverPop.start({
            coverId:             'CoverPop-cover',       // set default cover id
            
            expires:             365,                    // duration (in days) before it pops up again
            
            closeClassNoDefault: 'CoverPop-close',       // close if someone clicks an element with this class and prevent default action
            closeClassDefault:   'CoverPop-close-go',    // close if someone clicks an element with this class and continue default action
            cookieName:          '_exit_intent',         // to change the plugin cookie name
            onPopUpOpen:         function() {},          // on popup open callback function
            onPopUpClose:        function() {
                console.log('Exit Intent Popup closed');
            },                                           // on popup close callback function
            forceHash:           'splash',               // hash to append to url to force display of popup (e.g. http://yourdomain.com/#splash)
            delayHash:           'go',                   // hash to append to url to delay popup for 1 day (e.g. http://yourdomain.com/#go)
            closeOnEscape:       true,                   // close if the user clicks escape
            delay:               0,                      // set an optional delay (in milliseconds) before showing the popup
            hideAfter:           null                    // set an optional time (in milliseconds) to autohide
        });
    }
    $(document).ready( function () {
        var $mcMailForm = $('#mc-embedded-subscribe-form');
        $('#mc-embedded-subscribe.btn').on('click', function(e){
            e.preventDefault();
            register($mcMailForm);
        });
        $('input').on('input', function(){
            $('.no-content').removeClass('error');
        });
        $('.CoverPop-close, #CoverPop-cover').click(function(){
            CoverPop.close();
            console.log('Exit Intent Popup closed - No Signup detected');
        });
        $('.popup-wrapper').on('click', function(e){
            e.stopPropagation();
        });
        function register($mcMailForm) {
            $.ajax({
                type: $mcMailForm.attr('method'),
                url: $mcMailForm.attr('action'),
                data: $mcMailForm.serialize(),
                cache       : false,
                dataType    : 'json',
                contentType: "application/json; charset=utf-8",
                error       : function(err) { console.log('connection error contact hello@WEMAKEWEBSITES.COM') },
                success     : function(data) {
                    if (data.result != "success") {
                        $('.no-content').addClass('error').html(data.msg);
                    } else {
                        $('.mc-field-group').removeClass('error');
                        $('#mc_embed_signup_form').html('<h3>Thank you. Please check your email.</h3>');
                        $("body").delay(2500).queue(function() {
                            CoverPop.close();
                            console.log('Exit Intent Popup closed with signup - Exit intent diactivated');
                        });
                        $.cookie("_exit_intent", "signedup", { expires: 365 , path: '/' });
                    }
                }
            });
        }
         
        function delayIntent(){
 
            // Exit intent
            function addEvent(obj, evt, fn) {
                if (obj.addEventListener) {
                    obj.addEventListener(evt, fn, false);
                }
                else if (obj.attachEvent) {
                    obj.attachEvent("on" + evt, fn);
                }
            }
              
            // Exit intent trigger
            addEvent(document, 'mouseout', function(evt) {
                if( popQueue.length == 0 ){
                    if (evt.toElement == null && evt.relatedTarget == null ) {
                        if( ( $.cookie('_exit_intent') != 'true' ) ){
                            console.log('Exit Intent: Mouse has left the area');
                            console.log('No Exit Intent Cookie Found');
                            console.log('Exit Intent Popup Deployed');
                            $.removeCookie('_exit_intent', { path: '/' }); // => true
                            setTimeout( startPopup, 800);
                        } else if( ( $.cookie('_exit_intent') == 'true' ) ){
                            console.log('Exit Intent Closed - No Signup Detected - Exit Intent Delayed');
                        } else if( ( $.cookie('_exit_intent') == 'signedup' ) ){
                            console.log('Exit Intent Cookie Detected - Signup Detected - Exit Intent Deactivated');
                        }
                    };
                } else {
                    console.log('There is another popup open');
                }
            });
 
            console.log('Exit Intent is Active');
        }
 
        setTimeout( delayIntent, 1000 );
    });
})(jQuery);